import { render, staticRenderFns } from "./SpecialitiesTabs.vue?vue&type=template&id=05200006&"
import script from "./SpecialitiesTabs.vue?vue&type=script&lang=js&"
export * from "./SpecialitiesTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports